// nosemgrep: no-legacy-api-store
import apiStore from '@/legacy/store/modules/apiBuilder'
import { AskAProfileResponse } from '@/libs/features/llm/types'

export const useAskAProfileApi = apiStore<AskAProfileResponse>(
  'askAProfileApi',
  '/api/ask_a_profile'
)
